import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { UtilsService } from 'src/app/modules/shared/services/utils.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-hpv-consent',
  templateUrl: './hpv-consent.component.html',
  // styleUrls: ['./hpv-consent.component.scss'],
})
export class HpvConsentComponent implements OnInit {
  ENV = environment;
  @Output() isConsentAgreed: EventEmitter<boolean> = new EventEmitter();
  isBottomSheet = false;
  readAllConsent = false;
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<HpvConsentComponent>,
    readonly util: UtilsService
  ) {}
  ngOnInit(): void {}

  dismissModal() {
    this._bottomSheetRef.dismiss(this.readAllConsent);
  }

  isConsentChecked() {
    if (!this.readAllConsent) {
      this.util.presentToastError('Please select the consent');
      return;
    }
    this.dismissModal();
  }
}
